import React from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router';
import moment from 'moment';
import axios from './../../../constants/axios';

class UnpaidBill extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         pendingBills: []
      };
   }

   componentDidMount() {
      axios.get('inventorySales/getPendingBills')
         .then((res) => {
            this.setState({
               pendingBills: res.data
            });
         });
   }

   render() {
      const { pendingBills } = this.state;
      return (
         <Table >
            <thead >
            <tr >
               <th >#inv Id</th >
               <th >Contact Name</th >
               <th >Expected Bill Amount</th >
               <th >Inv Created</th >
               <th >##</th >
            </tr >
            </thead >
            <tbody >
            {pendingBills.map((bill) => (
               <tr key={bill.id} >
                  <td >{bill.id}</td >
                  <td >{bill.contact_name}</td >
                  <td >{bill.amount}</td >
                  <td >{moment(bill.created_at).format('DD/MM/YYYY h:mm a')}</td >
                  <td >
                     <Link to={`/sale/saleInvoiceDetail/${bill.id}`} >Details</Link >
                  </td >
               </tr >
            ))}
            </tbody >
         </Table >
      );
   }
}

export default UnpaidBill;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/PendingBill.js
 **/